/* Segway handleidingen: filteren op model, soort en zoekterm. De lijst staat al volledig op de pagina, dit script verbergt alleen wat niet past. */
(function () {
  var root = document.querySelector('[data-man]');
  if (!root) return;
  var select = root.querySelector('[data-man-model]');
  var search = root.querySelector('[data-man-search]');
  var chips = [].slice.call(root.querySelectorAll('[data-man-chip]'));
  var items = [].slice.call(root.querySelectorAll('[data-man-item]'));
  var count = root.querySelector('[data-man-count]');
  var empty = root.querySelector('[data-man-empty]');
  var kind = 'alle';

  function apply() {
    var model = select ? select.value : '';
    var q = search ? search.value.toLowerCase().trim() : '';
    var shown = 0;
    items.forEach(function (item) {
      var models = ' ' + (item.getAttribute('data-models') || '') + ' ';
      var ok = (!model || models.indexOf(' ' + model + ' ') > -1) &&
        (kind === 'alle' || item.getAttribute('data-kind') === kind) &&
        (!q || (item.getAttribute('data-search') || '').indexOf(q) > -1);
      item.hidden = !ok;
      if (ok) shown += 1;
    });
    if (count) count.textContent = shown + (shown === 1 ? ' handleiding' : ' handleidingen');
    if (empty) empty.hidden = shown > 0 || items.length === 0;
  }

  if (select) select.addEventListener('change', apply);
  if (search) search.addEventListener('input', apply);
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      kind = chip.getAttribute('data-man-chip');
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      apply();
    });
  });

  try {
    var wanted = new URLSearchParams(window.location.search).get('model');
    if (wanted && select) {
      for (var i = 0; i < select.options.length; i += 1) {
        if (select.options[i].value === wanted) { select.value = wanted; break; }
      }
    }
  } catch (e) {}
  apply();
})();
